import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import { Lightbox } from "~assets/frontend/components/comp-lightbox/comp-lightbox";
import { dispatchTrackingEvent } from "~assets/global/tracking/tracking-event";
const LightboxWrapper = ({ group, lightboxes }) => {
    const [initialImage, setInitialImage] = useState(null);
    useEffect(() => {
        lightboxes.forEach(({ element, key }) => {
            const handler = (event) => {
                event.preventDefault();
                setInitialImage(key);
                dispatchTrackingEvent({
                    name: "ui",
                    payload: {
                        ui_component: "comp-lightbox",
                        ui_function: "toggle",
                        ui_action: "open",
                        ui_target: group,
                    },
                });
            };
            element.addEventListener("click", handler);
            return () => {
                element.removeEventListener("click", handler);
            };
        });
    }, [lightboxes, setInitialImage]);
    const images = lightboxes.map(({ key, src, alt, description }) => ({ key, src, alt, description: description !== null && description !== void 0 ? description : "" }));
    return (React.createElement(Lightbox, { key: group, initialImage: initialImage, images: images, onClose: () => {
            setInitialImage(null);
        } }));
};
export const LightboxLoader = (triggers) => {
    const lightboxesByGroup = new Map();
    triggers.forEach((triggerElement, i) => {
        var _a;
        // image source
        const imageSrc = triggerElement.getAttribute("data-lightbox-image");
        if (!imageSrc) {
            throw new Error("Lightbox data-lightbox-image attribute is empty");
        }
        // image alt
        const imageAlt = triggerElement.getAttribute("data-lightbox-alt");
        if (!imageAlt) {
            throw new Error("Lightbox data-lightbox-alt attribute is empty");
        }
        // Lightbox group – if not set, use "default" group
        let group = triggerElement.getAttribute("data-lightbox-group");
        if (!group) {
            group = "default";
        }
        // Optional image description
        let description = triggerElement.getAttribute("data-lightbox-description");
        if (typeof description === "string" && description.length === 0) {
            description = null;
        }
        if (!lightboxesByGroup.has(group)) {
            lightboxesByGroup.set(group, []);
        }
        (_a = lightboxesByGroup.get(group)) === null || _a === void 0 ? void 0 : _a.push({ key: "image" + i, element: triggerElement, src: imageSrc, alt: imageAlt, description: description });
    });
    lightboxesByGroup.forEach((lightboxes, group) => {
        var _a;
        const rootElement = document.createElement("div");
        ((_a = document.getElementById("storybook-document-body")) !== null && _a !== void 0 ? _a : document.body).appendChild(rootElement);
        const reactRoot = createRoot(rootElement);
        reactRoot.render(React.createElement(React.StrictMode, null,
            React.createElement(LightboxWrapper, { group: group, lightboxes: lightboxes })));
    });
};
